import type { SpartanProductFeatureCarouselTracking } from '@/app/lcv/components/sections/spartan/products/shared/feature-carousel/types';

export const getSpartanProductFeatureCarouselTracking = (
  prefix: string
): SpartanProductFeatureCarouselTracking => ({
  featureList: `${prefix}-feature-list`,
  feature: (index) => `${prefix}-feature-${index + 1}`,
  featureTitle: (index) => `${prefix}-feature-${index + 1}-title`,
  featureDescription: (index) => `${prefix}-feature-${index + 1}-description`,
  featureMedia: (index) => `${prefix}-feature-${index + 1}-media`,
  featurePrev: `${prefix}-feature-prev`,
  featureNext: `${prefix}-feature-next`,
  featureThumbnailList: `${prefix}-feature-thumbnail-list`,
  featureThumbnail: (index) => `${prefix}-feature-thumbnail-${index + 1}`,
  featureThumbnailPlayback: (index) =>
    `${prefix}-feature-thumbnail-${index + 1}-playback`,
  featureThumbnailImage: (index) =>
    `${prefix}-feature-thumbnail-${index + 1}-image`,
});
